import PublicForm from "../singleton/public-form";
import PublicApi from "../singleton/public-api";

export default {

    getAll: PublicForm.getAll.bind(PublicForm),

    get: PublicForm.get.bind(PublicForm),

    create: PublicForm.create.bind(PublicForm),

    update: PublicForm.update.bind(PublicForm),

    delete: PublicForm.delete.bind(PublicForm),

    clone: PublicForm.clone.bind(PublicForm),

    getFields: PublicForm.getFields.bind(PublicForm),

    getEmailOptions: PublicForm.getEmailOptions.bind(PublicForm),

    getByMapping: PublicForm.getByMapping.bind(PublicForm),

    getPublicLink: PublicApi.getFormAddress.bind(PublicApi),

    loadNotifications: PublicForm.loadNotifications.bind(PublicForm),

    setOrder: PublicForm.setOrder.bind(PublicForm)

}